import React, { Component } from 'react';
import { QuestionRendererProps } from './types';
import { MultipleChoiceRenderer } from './MultipleChoiceRenderer';
import { ColumnArithmeticRenderer } from './ColumnArithmeticRenderer';
import { MoneyAssemblerRenderer } from './MoneyAssemblerRenderer';
import { ClockRenderer } from './ClockRenderer';
export function QuestionRendererFactory(props: QuestionRendererProps) {
  const {
    question
  } = props;
  // Determine renderer based on question type
  const getRenderer = () => {
    switch (question.questionType) {
      case 'multiple_choice':
      case 'standard':
        return <MultipleChoiceRenderer {...props} data-id="element-1177" />;
      case 'cijferend_optellen':
      case 'cijferend_aftrekken':
        return <ColumnArithmeticRenderer {...props} data-id="element-1178" />;
      case 'geld_samenstellen':
        return <MoneyAssemblerRenderer {...props} data-id="element-1179" />;
      case 'klok_aflezen':
        return <ClockRenderer {...props} data-id="element-1180" />;
      default:
        // Fallback to multiple choice
        return <MultipleChoiceRenderer {...props} data-id="element-1181" />;
    }
  };
  return getRenderer();
}